// extracted by mini-css-extract-plugin
module.exports = {"plan":"plans_plan__24bhX","planPage":"plans_planPage__18n5K","cards":"plans_cards__2cOWS"};